import React from 'react';
import style from './style';
import commonStyle from '../style';
import {Grid, Typography} from "@mui/material";
import EAColorIcon from "../../../../../components/common/EAColorIcon";
import i18next from "i18next";
import Attribut from "./Attribut";
import clsx from "clsx";

const Attributs = ({context, readOnly = false}) => {
  const {classes} = style();
  const {classes: commonClasses} = commonStyle();

  return <Grid container spacing={2} className={clsx(classes.root,commonClasses.part)} id={'attributs'}>
    <Typography variant={'h3'} className={commonClasses.partTitle}>
      <EAColorIcon icon={'/context/contextModel/attributsPart'} svgStyle={{ marginRight: '5px', position: "relative", top: "3px" }}/>
      {`${i18next.t("demandes.contextModel.ficheModel.attributs")}`}
    </Typography>
    <div className={classes.attributsWrapper}>
      <Attribut
        title={i18next.t("demandes.contextModel.attributsContext")}
        attributContextType={"contextAttributes"}
        dialogTitle={i18next.t("attributes.createTitle")}
        readOnly={readOnly}
      />
      <Attribut
        title={i18next.t("demandes.contextModel.attributsTiers")}
        attributContextType={"tiersAttributes"}
        dialogTitle={i18next.t("attributes.createTitle")}
        readOnly={readOnly}
      />
      <Attribut
        title={i18next.t("demandes.contextModel.attributsDeclarant")}
        attributContextType={"demandeAttributes"}
        dialogTitle={i18next.t("attributes.createTitle")}
        readOnly={readOnly}
      />
    </div>
  </Grid>
}

export default Attributs;